export default __webpack_public_path__ + "static/media/Intelligence.0ac82502.png";